import { make } from 'vuex-pathify';
import { keyBy, keys, sortBy } from 'lodash';

const tips = keyBy(
    [
        {
            id: 1,
            text: 'Be assertive',
            selected: false
        },
        {
            id: 2,
            text: 'Meet in a quiet place',
            selected: false
        },
        {
            id: 3,
            text: 'Do it when you are sober',
            selected: false
        },
        {
            id: 4,
            text: 'Make sure you are safe: do it in a safe place (like a quiet bench in a park with people around, or a restaurant with other people around)',
            selected: false
        },
        {
            id: 5,
            text: 'Check a person’s tone and response concerning trans or gay issues',
            selected: false
        },
        {
            id: 6,
            text: 'Avoid introducing them to people who might tell them your T before you are ready to',
            selected: false
        },
        {
            id: 7,
            text: 'Disclose on the phone before meeting or hanging out',
            selected: false
        },
        {
            id: 8,
            text: 'Try avoiding sexual interactions and intimacy until you’ve discussed your T (I know that can be so hard!)',
            selected: false
        },
        {
            id: 9,
            text: 'Can you think of any other tips for telling a boo your T? Add them below:',
            value: '',
            selected: false
        }
    ],
    'id'
);
const tipsOrder = sortBy(keys(tips), k => parseInt(k));

const state = {
    title: 'Disclosure',
    complete: false,
    sticker: {
        text: 'Rainbow in an arc',
        earned: false,
        image: require('@/assets/stickers/stickers_0009_rainbow.png')
    },
    bonusSticker: false,
    trophy: false,
    tips,
    tipsOrder
};
const getters = make.getters(state);
const mutations = make.mutations(state);
const actions = make.actions(state);

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
